import ReactGA from 'react-ga4';

// One visitor action, sent to Google Analytics and to our own counters (ListingStat in the
// backend: counts only, no cookies). Kinds: feed_view, reels_open, view, play, contact,
// agent_profile, share, copy_link, copy_source. Never throws: tracking must not break the page.
const EVENTS_URL = '/api/v1/listings/events/';

export function track(kind, listing = null) {
  try {
    ReactGA.event(kind, listing ? {
      listing_id: listing.id,
      platform: listing.platform,
      agent: listing.account,
      city: listing.city || undefined,
      property_type: listing.property_type || undefined,
    } : {});
  } catch (e) { /* analytics blocked */ }

  const body = JSON.stringify({ kind, listing: listing ? listing.id : null });
  try {
    // sendBeacon survives the page being left (e.g. the click that opens TikTok).
    if (navigator.sendBeacon && navigator.sendBeacon(EVENTS_URL, new Blob([body], { type: 'application/json' }))) return;
  } catch (e) { /* fall back to fetch */ }
  try {
    fetch(EVENTS_URL, { method: 'POST', body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
  } catch (e) { /* ignore */ }
}
